import commonApi from "@/api/common.api.js";

export default {
    state: {
        // 뉴스리스트
        newsDataList: [],
    },

    getters: {
    	getNewsDataList(state) {
            return state.newsDataList;
        }
    },

    mutations: {
    	SET_FETCH_NEWS_DATA_LIST(state, newsDataList) {
            state.newsDataList = newsDataList;
        }
    },

    actions: {
    	FETCH_NEWS_DATA_LIST({commit}, paramObj) {
            return commonApi.fetchNewsDataList(paramObj.dataKdSqno, paramObj.dataSqno)
                .then(res => {
                    commit('SET_FETCH_NEWS_DATA_LIST', res.data.data);
                })
        }
    },

};
